<template>
  <div
    id="commonGrecaptcha"
  />
</template>
<script>
export default {
  data () {
    return {
      captchaWidgetId: 0,
      gaptchPromise: {},
    }
  },
  beforeDestroy () {
    if (window.grecaptcha && this.captchaWidgetId) {
      window.grecaptcha.reset(this.captchaWidgetId)
    }
  },
  methods: {
    insertScript () {
      return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
          const script = document.createElement('script')
          script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=explicit'
          script.onload = () => {
            setTimeout(() => {
              resolve()
            }, 500)
          }
          script.onerror = reject
          document.body.appendChild(script)
        } else {
          resolve()
        }
      })
    },
    async validate () {
      await this.insertScript()
      return new Promise((resolve, reject) => {
        this.gaptchPromise = {
          resolve,
          reject
        }
        if (this.captchaWidgetId) {
          window.grecaptcha.reset(this.captchaWidgetId)
          window.grecaptcha.execute(this.captchaWidgetId)
          return
        }
        this.captchaWidgetId = window.grecaptcha.render('commonGrecaptcha', {
          sitekey: '6LcgpqMUAAAAAPlMI69DQtsZ5hGDpXEDP5SKcyqL',
          size: 'invisible',
          isolated: true,
          callback: (token) => {
            console.log('Verified: not robot', token)
            this.gaptchPromise.resolve(token)
          },
          'error-callback': () => {
            this.gaptchPromise.reject(new Error('验证失败'))
          }
        })
        window.grecaptcha.execute(this.captchaWidgetId)
      })
    },
  }
}
</script>
